import { AfterViewInit, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NotificationService } from 'app/_services/notification.service';
import { UserValidation } from 'app/general/_models/user-validation-model';
import { UserValidationService } from '../../user-validation.service';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { CELLPHONE_MASK, PHONE_ALTERNATIVE_MASK } from 'app/_utils/general-masks';

declare const $: any;

@Component({
    selector: 'app-user-email-whatsapp-validation', templateUrl: './user-email-whatsapp-validation.component.html', styleUrls: ['./user-email-whatsapp-validation.component.scss'],
    standalone: false
})
export class UserEmailWhatsappValidationComponent implements OnInit, AfterViewInit {
    @Input() isWhatsapp: boolean;
    @Input() user: UserValidation;
    @Output() onNextStepClick: EventEmitter<void> = new EventEmitter<void>();

    cellphoneMask = PHONE_ALTERNATIVE_MASK;

    tokenAlreadySended: boolean = false;
    tokenControlList: FormControl<number | string>[];

    emailControl = new FormControl('', [Validators.required, Validators.email]);
    whatsappControl = new FormControl('', [Validators.required]);

    fb = inject(FormBuilder);
    tokenFormGroup = this.fb.group({
        tokenFirstDigit: [null as number | string],
        tokenSecondDigit: [null as number | string],
        tokenThirdDigit: [null as number | string],
        tokenFourthDigit: [null as number | string],
        tokenFifthDigit: [null as number | string],
        tokenSixthDigit: [null as number | string],
    });

    constructor(private userValidationService: UserValidationService, private notificationService: NotificationService, private ngxLoader: NgxUiLoaderService) {}

    ngOnInit(): void {
        this.cellphoneMask = this.user.whatsapp.length == 11 ? CELLPHONE_MASK : PHONE_ALTERNATIVE_MASK;

        this.emailControl.setValue(this.user.email);
        this.whatsappControl.setValue(this.user.whatsapp);

        this.tokenControlList = [
            this.tokenFormGroup.controls.tokenFirstDigit as FormControl,
            this.tokenFormGroup.controls.tokenSecondDigit as FormControl,
            this.tokenFormGroup.controls.tokenThirdDigit as FormControl,
            this.tokenFormGroup.controls.tokenFourthDigit as FormControl,
            this.tokenFormGroup.controls.tokenFifthDigit as FormControl,
            this.tokenFormGroup.controls.tokenSixthDigit as FormControl,
        ];

        this.whatsappControl.valueChanges.subscribe((value) => {
            if (value.length == 0)
                return;

            if (value.length == 10)
                this.whatsappControl.setErrors(null);

            this.cellphoneMask = value.length > 10 ? CELLPHONE_MASK : PHONE_ALTERNATIVE_MASK;
        });

        this.tokenControlList.forEach((control, index) => control.valueChanges.subscribe((value) => {
            if (value == null || value.toString().length == 0)
                return;

            if (this.tokenControlList.length - 1 == index) {
                $(`#submitTokenButton`).focus();
                return;
            }

            $(`#token${index + 1}`).focus();
        }));
    }

    ngAfterViewInit() {
        this.whatsappControl.setErrors(null);
    }

    handleInputSubmit(): void {
        if (this.isWhatsapp)
            return this.whatsappSubmit();

        this.emailSubmit();
    }

    handleTokenSubmit(): void {
        if (this.isWhatsapp)
            return this.whatsappTokenSubmit();

        this.emailTokenSubmit();
    }

    emailSubmit(): void {
        var email = this.emailControl.value;

        if (this.emailControl.invalid)
            return this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.form.validation-message.email', { translateMessage: true });

        this.ngxLoader.startLoader('loader-user-validation');

        this.userValidationService.updateUserEmail(email).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response.success) {
                    this.tokenAlreadySended = true;
                    this.tokenFormGroup.reset();
                    this.ngxLoader.stopLoader('loader-user-validation');
                }
            },
            error: () => {
                this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.messages.error.input-submit', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-user-validation');
            }
        })
    }

    emailTokenSubmit(): void {
        var token = this.tokenControlList.map(x => x.value).join('');

        if (token.length < 6 || isNaN(parseInt(token)))
            return this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.form.validation-message.token', { translateMessage: true });

        this.ngxLoader.startLoader('loader-user-validation');

        this.userValidationService.updateUserEmailConfirmation(token).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response.success) {
                    this.notificationService.showSuccessToastr('geral.user-validation.email-whatsapp.messages.success.email', { translateMessage: true });
                    this.user.email = this.emailControl.value;
                    this.nextStep();
                    this.ngxLoader.stopLoader('loader-user-validation');
                }
            },
            error: () => {
                this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.messages.error.token-submit', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-user-validation');
            }
        })
    }

    goBackToInput() {
        this.tokenAlreadySended = false;
    }

    nextStep(): void {
        this.tokenAlreadySended = false;
        this.onNextStepClick.emit();
    }

    onKeyUpToken(value: KeyboardEvent, index: number) {
        if (index > 0 && value.key === 'ArrowLeft')
            return $(`#token${index - 1}`).focus();

        if (index < (this.tokenControlList.length - 1) && value.key === 'ArrowRight')
            return $(`#token${index + 1}`).focus();

        if (index > 0 && value.key == 'Backspace') {
            if (this.tokenControlList[index].value == null) {
                $(`#token${index - 1}`).focus();
                this.tokenControlList[index - 1].setValue(null);
                return;
            } else {
                this.tokenControlList[index].setValue(null);
                return;
            }
        }

        if (this.tokenControlList[index].value != null && !isNaN(parseInt(value.key, 10)))
            this.tokenControlList[index].setValue(parseInt(value.key, 10));
    }

    onPasteToken($event: ClipboardEvent, index: number) {
        $event.preventDefault();
        var clipboardData = $event.clipboardData;
        var pastedData = clipboardData.getData('Text');
        var numbers = pastedData.match(/\d/g).map(n => parseInt(n));

        this.tokenControlList.forEach((control, i) => {
            if (i < index || numbers.length == 0)
                return;

            if (control.value == null || control.value.toString().length == 0)
                control.setValue(numbers.shift());

        });
    }

    whatsappSubmit(): void {
        var whatsapp = this.whatsappControl.value;

        if (this.whatsappControl.invalid)
            return this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.form.validation-message.whatsapp', { translateMessage: true });

        this.ngxLoader.startLoader('loader-user-validation');

        this.userValidationService.updateUserWhatsapp(whatsapp).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response.success) {
                    this.tokenAlreadySended = true;
                    this.tokenFormGroup.reset();
                    this.ngxLoader.stopLoader('loader-user-validation');
                }
            },
            error: () => {
                this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.messages.error.input-submit', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-user-validation');
            }
        })
    }

    whatsappTokenSubmit(): void {
        var token = this.tokenControlList.map(x => x.value).join('');

        if (token.length < 6 || isNaN(parseInt(token)))
            return this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.form.validation-message.token', { translateMessage: true });

        this.ngxLoader.startLoader('loader-user-validation');

        this.userValidationService.updateUserWhatsappConfirmation(token).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response.success) {
                    this.notificationService.showSuccessToastr('geral.user-validation.email-whatsapp.messages.success.whatsapp', { translateMessage: true });
                    this.user.whatsapp = this.whatsappControl.value;
                    this.nextStep();
                    this.ngxLoader.stopLoader('loader-user-validation');
                }
            },
            error: () => {
                this.notificationService.showErrorToastr('geral.user-validation.email-whatsapp.messages.error.token-submit', { translateMessage: true });
                this.ngxLoader.stopLoader('loader-user-validation');
            }
        })
    }
}
